import { ThreadHeader } from "@/app/Threads/Components/ThreadHeader";
import { ThreadMessagesView } from "@/app/Threads/Components/ThreadMessagesView";
import { ThreadActivityProvider } from "@/app/Threads/Components/ThreadActivityProvider";
import { ThreadPresenceProvider } from "@/app/Threads/Components/ThreadPresenceProvider";
import { threadRecordQuery } from "@/app/Threads/GraphQL/threadQueries";
import { useMarkThreadAsRead } from "@/app/Threads/hooks/useMarkThreadAsRead";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { hasUnread } from "@/app/Threads/utils/hasUnread";
import { cn } from "@/lib/utils";
import { Suspense, useEffect } from "react";

export function ThreadView({
  id,
  autoFocus = true,
  className,
}: {
  id: string;
  autoFocus?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("flex min-h-0 flex-1 flex-col", className)}>
      <Suspense>
        <ThreadAutoRead id={id} />
        <ThreadPresenceProvider key={id} threadId={id}>
          <ThreadActivityProvider>
            <ThreadHeader id={id} />
            <ThreadMessagesView id={id} autoFocus={autoFocus} />
          </ThreadActivityProvider>
        </ThreadPresenceProvider>
      </Suspense>
    </div>
  );
}

function ThreadAutoRead({ id }: { id: string }) {
  const { data } = useSuspenseGqlQuery(threadRecordQuery, { id });
  const { mutate: markAsRead } = useMarkThreadAsRead();

  const unread = data?.thread ? hasUnread(data.thread) : false;

  useEffect(() => {
    if (unread) {
      markAsRead({ thread_id: id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return null;
}
